import { useState, useRef } from 'react';
import { Message } from '../types';

export const useConversation = () => {
  const [messages, setMessages] = useState<Message[]>([]);
  const sequenceRef = useRef(0);

  const addMessage = (newMsg: Message) => {
    setMessages((prev) => {
      const exists = prev.find(msg => msg.itemId === newMsg.itemId);
      if (exists) {
        if (newMsg.isFinal) {
          console.log(`📝 Finalizing ${newMsg.role} message:`, newMsg.itemId, newMsg.text);
          return prev.map(msg =>
            msg.itemId === newMsg.itemId ? { ...msg, text: newMsg.text } : msg
          );
        } else {
          return prev.map(msg =>
            msg.itemId === newMsg.itemId ? { ...msg, text: msg.text + newMsg.text } : msg
          );
        }
      } else {
        // Add sequence number for proper ordering
        const messageWithSequence = {
          ...newMsg,
          sequence: sequenceRef.current++
        };
        console.log(`➕ New ${newMsg.role} message:`, messageWithSequence.itemId, `seq: ${messageWithSequence.sequence}`, newMsg.text.substring(0, 50));
        return [...prev, messageWithSequence];
      }
    });
  };
  
  const clearMessages = () => {
    sequenceRef.current = 0;
    setMessages([]);
  };

  return { messages, addMessage, clearMessages };
};
